import Vue from 'vue';
import { getPassportUrl } from '@/utils/other';
export default Vue.extend({
    name: 'greetingPopupChunk',
    methods: {
        toAccount() {
            window.open(getPassportUrl('/id/', { withAcceptor: true }), '_blank');
        }
    }
});
